import {
    MAC_DETAILS_FETCH_DATA_LOADED,
    MAC_DETAILS_FETCH_DATA_STARTED,
    MAC_DETAILS_FETCH_DATA_STORE,
    MAC_MENUS_FETCH_DATA_STARTED,
    MAC_MENUS_FETCH_DATA_LOADED,
    MAC_MENUS_FETCH_DATA_STORE,
    MAC_MENUS_RESET_DATA,
    MAC_DOWNLOAD_LINK_STARTED,
    MAC_DOWNLOAD_LINK_LOADED,
} from '../actions/actionsNamesList';

const defaultState = {
    loading: false,
    loadingDownloadLink: false,
    data: {},
    dataTable: {
        data: [],
        recordsFiltered: 0,
        recordsTotal: 0
    },
};

export default function macData(state = defaultState, action) {
    switch (action.type) {
        case MAC_DETAILS_FETCH_DATA_STARTED: {
            return {
                ...state,
                loading: true
            };
        }
        case MAC_DETAILS_FETCH_DATA_LOADED: {
            return {
                ...state,
                loading: false
            };
        }
        case MAC_DETAILS_FETCH_DATA_STORE: {
            return {
                ...state,
                data: action.data
            };
        }
        case MAC_MENUS_FETCH_DATA_STARTED: {
                return {
                    ...state,
                    loadingMenus: true
                };
            }
        case MAC_MENUS_FETCH_DATA_LOADED: {
            return {
                ...state,
                loadingMenus: false
            };
        }
        case MAC_MENUS_FETCH_DATA_STORE: {
            return {
                ...state,
                dataTable: action.data
            };
        }
        case MAC_MENUS_RESET_DATA: {
            return defaultState;
        }
        case MAC_DOWNLOAD_LINK_STARTED: {
            return {
                ...state,
                loadingDownloadLink: true
            };
        }
        case MAC_DOWNLOAD_LINK_LOADED: {
            return {
                ...state,
                loadingDownloadLink: false
            };
        }
        default: {
            return state;
        }
    }
}
